import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OtpInitialization } from '../../interfaces/otp-initialization.interface';
import { AppRoutesEnum } from '../../enums/app-routes.enum';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { login } from '../store/actions/auth.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActionsSubject, Store } from '@ngrx/store';
import * as AuthActions from '../store/actions/auth.actions';
import { TranslateService } from '@ngx-translate/core';
import { ofType } from '@ngrx/effects';
import { ErrorMessagesConfig } from '@frogo-kit/core';

@UntilDestroy()
@Component({
    selector: 'aft-otp-setup',
    templateUrl: './otp-setup.component.html',
    standalone: false,
})
export class OtpSetupComponent implements OnInit {
  public readonly otpData: OtpInitialization;
  public otpCodeControl = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(6),
  ]);
  public errorsConfig: ErrorMessagesConfig = {
    otpCodeInvalid: () => this._translate.instant('loginOtpError'),
  };

  private readonly _password: string;
  private readonly _login: string;

  constructor(
    private _domSanitizer: DomSanitizer,
    private _router: Router,
    private _store: Store,
    private _actionsStream: ActionsSubject,
    private _translate: TranslateService,
  ) {
    const routerState = this._router.getCurrentNavigation()?.extras?.state;
    this._password = routerState?.['password'];
    this._login = routerState?.['login'];
    this.otpData = routerState?.['otpInitData'] as OtpInitialization;
    if ( !this.otpData && !this._password && !this._login ) this._router.navigate([AppRoutesEnum.Login]);
  }

  public ngOnInit(): void {
    this._initSubs();
  }

  public verifyOTPCode(): void {
    this._store.dispatch(login({
      username: this._login,
      password: this._password,
      otp_code: this.otpCodeControl.value,
    }));
  }

  protected getImageSrc(): SafeResourceUrl {
    return this._domSanitizer.bypassSecurityTrustResourceUrl(
      `data:image/png;base64,${this.otpData.qr}`,
    );
  }

  private _initSubs(): void {
    this._actionsStream
      .pipe(
        untilDestroyed(this),
        ofType(AuthActions.loginFailure),
      )
      .subscribe(() => {
        this.otpCodeControl.setErrors({
          otpCodeInvalid: true,
        });
      });
  }
}
